import { render, staticRenderFns } from "./ResultsHeader.vue?vue&type=template&id=e18e4140"
import script from "./ResultsHeader.vue?vue&type=script&lang=js"
export * from "./ResultsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports